// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1Cbn8","label":"Section_label__3-hdL","contentWrap":"Section_contentWrap__wq03C","footer":"Section_footer__3ulGK","footerInner":"Section_footerInner__N10yZ"};